// @flow
import * as React from 'react';
import styled from 'styled-components';
import theme from 'styled-theming';
import ErrorAlert from '../Common/ErrorAlert';
import Typography, { UnderlinedTypography } from '../Common/Typography';
import TextBox from '../Common/TextBox';
import { Button } from '../Common/Button';
import Themes from '../../styling/themes';
import LoginImage from '../../images/LoginImage.jpg';

const backgroundColor = theme('mode', {
  light: Themes.light.cardBackgroundColor,
  dark: Themes.dark.cardBackgroundColor,
  custom: Themes.custom.cardBackgroundColor
});

const color = theme('mode', {
  light: Themes.light.cardColor,
  dark: Themes.dark.cardColor,
  custom: Themes.custom.cardColor
});

const Page = styled.div`
  align-items: center;
  color: #fff;
  display: flex;
  height: 100vh;
  justify-content: center;
`;

const LoginContainer = styled.div`
  border: 1px solid lightgrey;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);
  display: flex;
  height: 450px;
  width: 700px;
`;

const LeftColumn = styled.div`
  align-items: center;
  background-image: url(${LoginImage});
  display: flex;
  justify-content: center;
  flex: 1;
  flex-direction: column;
  text-align: center;
`;

const RightColumn = styled.div`
  background-color: ${backgroundColor};
  color: ${color};
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 1rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

const FormInputs = styled.div`
  margin-top: 1rem;
`;

const InputGroup = styled.div`
  margin-bottom: 0.5rem;
`;

const Label = styled.label`
  display: block;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

type Props = {
  companyName: string,
  userName: string,
  password: string,
  errors: Array<string>,
  onChange: (SyntheticKeyboardEvent<HTMLInputElement>) => mixed,
  onClickForgottenPassword: () => void,
  onSubmit: (SyntheticEvent<HTMLButtonElement>) => mixed
};

const LoginDesktop = React.memo<Props>((props: Props) => (
  <Page>
    <LoginContainer>
      <LeftColumn>
        <Typography kind="h1">{props.companyName}</Typography>
        <Typography kind="h2">Self Service</Typography>
      </LeftColumn>
      <RightColumn>
        <UnderlinedTypography kind="h1">Login</UnderlinedTypography>
        <Form onSubmit={props.onSubmit}>
          <FormInputs>
            <InputGroup>
              <Label htmlFor="userName">User Name</Label>
              <TextBox
                autoFocus
                autoCapitalize="false"
                type="text"
                id="userName"
                name="userName"
                placeholder="Enter user name"
                fullWidth
                value={props.userName}
                onChange={props.onChange}
              />
            </InputGroup>
            <InputGroup>
              <Label htmlFor="password">Password</Label>
              <TextBox
                autoCapitalize="false"
                type="password"
                id="password"
                name="password"
                placeholder="Enter password"
                fullWidth
                value={props.password}
                onChange={props.onChange}
              />
            </InputGroup>
            <ErrorAlert errors={props.errors} />
          </FormInputs>
          <ButtonContainer>
            <Button
              kind="secondary"
              type="button"
              onClick={props.onClickForgottenPassword}
            >
              Forgotten Password
            </Button>
            <Button kind="primary" type="submit">
              Login
            </Button>
          </ButtonContainer>
        </Form>
      </RightColumn>
    </LoginContainer>
  </Page>
));

export default LoginDesktop;
